export default {
  label: 'Line terminator',
  placeholder: 'Choose a line terminator',
};
